import { render, staticRenderFns } from "./KnittingQcDetailRow.vue?vue&type=template&id=684e5f08&scoped=true"
import script from "./KnittingQcDetailRow.vue?vue&type=script&lang=js"
export * from "./KnittingQcDetailRow.vue?vue&type=script&lang=js"
import style0 from "./KnittingQcDetailRow.vue?vue&type=style&index=0&id=684e5f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e5f08",
  null
  
)

export default component.exports